import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useMutation } from '@tanstack/react-query';
import { TUserRoles } from '@/features/users/schemas/users.schema.ts';

type PostLoginResponse =
  | {
      refreshToken: {
        expiresAt: number;
      };
      role: TUserRoles;
    }
  | { redirectTo: 'TOTP_VERIFICATION' };

async function login({
  email,
  password,
}: {
  email: string;
  password: string;
}): Promise<PostLoginResponse | undefined> {
  try {
    const { data } = await client.post<PostLoginResponse>('/auth/login', {
      email,
      password,
    });

    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}`);
    }
  }
}

export const useLoginUserQuery = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: PostLoginResponse) => void;
  } = {
    onSuccess: undefined,
  }
) => {
  return useMutation({
    mutationFn: login,
    onSuccess: (data) => {
      if (data && onSuccess) onSuccess(data);
    },
  });
};
